export default "__VITE_ASSET__DFhWk9Zz__"